import React, { useEffect } from "react";
import { TextDescription, TextTitle } from "components/Texts";
import { useDispatch, useSelector } from "react-redux";

import DateFormatter from "modules/utils/DateFormatter";
import Section from "components/Section";
import Separator from "components/Separator";
import Table from "components/Table";
import TextSubscript from "components/TextSubscript";
import formatNumber from "modules/utils/formatNumber";
import mainSelectors from "modules/main/selectors";
import paymentActions from "modules/payment/actions";
import paymentSelectors from "modules/payment/selectors";
import useCurrency from "modules/utils/useCurrency";
import { useTranslation } from "react-i18next";

const PaymentHistory = () => {
  const paymentHistory = useSelector((state) => paymentSelectors.paymentHistory(state));
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const dispatch = useDispatch();
  const currency = useCurrency();

  useEffect(() => {
    const cusId = currentAd.ads_account_id;
    const accountType = currentAd.type;
    dispatch(paymentActions.GetPaymentHistory(cusId, accountType));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAd]);

  useEffect(() => {
    console.log(paymentHistory);
  }, [paymentHistory]);

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const tableColumn = [
    {
      key: "date",
      title: t("__date"),
      options: {
        strongText: true,
      },
    },
    {
      key: "amount",
      title: t("__amount"),
      options: {
        align: "right",
        fontSize: "14px",
      },
    },
  ];
  const tableData = paymentHistory.lists
    ? paymentHistory.lists.map((item) => {
        if (currentAd.type === "g_ads") {
          item.amount = (
            <TextSubscript
              align="right"
              valueText={formatNumber(item.clickcost_paygoogle)}
              subscriptText={currency}
              valueSize="14px"
              subscriptSize="10px"
              regular
            />
          );
          const dateObj = new Date(item.pay_on_date.replace(/\s/, "T"));
          item.date = DateFormatter.formatDateFull(dateObj);
        }
        return item;
      })
    : [];
  tableData.reverse();
  return (
    <Section margin="0">
      <TextTitle>{t("__payment_history")}</TextTitle>
      <TextDescription>{t("__recent_items")}</TextDescription>
      <Separator></Separator>
      <Table columns={tableColumn} data={tableData}></Table>
    </Section>
  );
};

export default PaymentHistory;
